// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import './layerControlWidget';

/**
 * @class Allows Opacity control for a layer.
 * @name TransparencyLayerControlWidget
 * @constructor
 * @extends {LayerControlWidget}
 */
myw.TransparencyLayerControlWidget = myw.ILayerControlWidget.extend({
    tagName: 'div',
    className: 'transparency-layer-widget',

    events: {
        click: 'noop'
    },

    render() {
        const defaultTransparency = this.options.layer.layerDef.transparency || 0;

        const sliderControl = new myw.WidgetSliderControl({
            defaultValue: defaultTransparency,
            rangeStep: 5,
            tooltipLabel: this.msg('tooltip'),
            unit: '%',
            minRangeLabel: this.msg('minRangeLabel'),
            maxRangeLabel: this.msg('maxRangeLabel'),
            onChange: this.onChange.bind(this)
        });

        this.$el.append(sliderControl.$el);
    },

    onChange(value) {
        const opacity = this._transparencyToOpacity(value);
        if (typeof this.options.layer.leafletLayer.setOpacity !== 'undefined') {
            this.options.layer.leafletLayer.setOpacity(opacity);
        }
    },

    _transparencyToOpacity(value) {
        return 1.0 - value / 100;
    },

    noop(ev) {
        ev.stopPropagation();
    }
});

export default myw.TransparencyLayerControlWidget;
